import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';

import { useLeadLabels, useProperties, usePropertyLabels } from 'src/services/api';
import { LeadsIcon, PropertiesIcon, UsersIcon } from 'src/icons';
import Chip from 'src/components/chip/Chip';
import { useConversationsPageContext } from 'src/pages/landlord/conversations/context';
import {
    getAssigneesFilterLabel,
    getIngestionSourcesFilterLabel,
    getLeadStagesFilterLabel,
    getLeadLabelsFilterLabel,
    getExcludeLeadLabelsFilterLabel,
    getPropertyFilterLabel,
    getPropertyLabelsFilterLabel,
    getArchivalStatusFilterLabel
} from 'src/pages/landlord/conversations/utils/filter-tabs';

import styles from 'src/pages/landlord/conversations/components/header/ConversationFilterStatus.module.css';

export default function ConversationsFilterStatus() {
    const { data: leadLabels } = useLeadLabels();
    const { data: properties } = useProperties();
    const { data: propertyLabels } = usePropertyLabels();

    const { teamMembers, filter, setFilter } = useConversationsPageContext();

    const assigneesFilterLabel = getAssigneesFilterLabel(filter.assigneeIds, teamMembers);
    const isFilteringByAssignees = assigneesFilterLabel !== undefined;

    const ingestionSourcesFilterLabel = getIngestionSourcesFilterLabel(filter.ingestionSources);
    const isFilteringByIngestionSources = ingestionSourcesFilterLabel !== undefined;

    const leadStagesFilterLabel = getLeadStagesFilterLabel(filter.leadStages);
    const isFilteringByLeadStages = leadStagesFilterLabel !== undefined;

    const leadLabelsFilterLabel = getLeadLabelsFilterLabel(filter.leadLabelIds, leadLabels);
    const isFilteringByLeadLabels = leadLabelsFilterLabel !== undefined;

    const excludeLeadLabelsFilterLabel = getExcludeLeadLabelsFilterLabel(filter.excludeLeadLabelIds, leadLabels);
    const isFilteringByExcludeLeadLabels = excludeLeadLabelsFilterLabel !== undefined;

    const isFilteringByArchivalStatus = filter.leadIsArchived !== undefined;
    const archivalStatusFilterLabel = getArchivalStatusFilterLabel(filter.leadIsArchived);

    const propertyFilterLabel = getPropertyFilterLabel(filter.propertyIds, properties);
    const isFilteringByProperty = propertyFilterLabel !== undefined;

    const propertyLabelsFilterLabel = getPropertyLabelsFilterLabel(filter.propertyLabelIds, propertyLabels);
    const isFilteringByPropertyLabels = propertyLabelsFilterLabel !== undefined;

    return (
        <>
            {isFilteringByAssignees && (
                <Tooltip title={assigneesFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={assigneesFilterLabel}
                            icon={<UsersIcon />}
                            onDelete={() => setFilter({ assigneeIds: [] })}
                        />
                    </div>
                </Tooltip>
            )}

            {isFilteringByIngestionSources && (
                <Tooltip title={ingestionSourcesFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={ingestionSourcesFilterLabel}
                            icon={<DownloadRoundedIcon />}
                            onDelete={() => setFilter({ ingestionSources: [] })}
                        />
                    </div>
                </Tooltip>
            )}

            {isFilteringByLeadStages && (
                <Tooltip title={leadStagesFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={leadStagesFilterLabel}
                            icon={<LeadsIcon />}
                            onDelete={() => setFilter({ leadStages: [] })}
                        />
                    </div>
                </Tooltip>
            )}

            {isFilteringByLeadLabels && (
                <Tooltip title={leadLabelsFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={leadLabelsFilterLabel}
                            icon={<LeadsIcon />}
                            onDelete={() => setFilter({ leadLabelIds: [] })}
                        />
                    </div>
                </Tooltip>
            )}

            {isFilteringByExcludeLeadLabels && (
                <Tooltip title={excludeLeadLabelsFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={excludeLeadLabelsFilterLabel}
                            icon={<LeadsIcon />}
                            onDelete={() => setFilter({ excludeLeadLabelIds: [] })}
                        />
                    </div>
                </Tooltip>
            )}

            {isFilteringByArchivalStatus && (
                <Chip className={styles.animatedFadeIn}
                    variant="outlined"
                    label={archivalStatusFilterLabel}
                    icon={<LeadsIcon />}
                    onDelete={() => setFilter({ leadIsArchived: undefined })}
                />
            )}

            {isFilteringByProperty && (
                <Tooltip title={propertyFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={propertyFilterLabel}
                            icon={<PropertiesIcon />}
                            onDelete={() => setFilter({ propertyIds: [] })}
                        />
                    </div>
                </Tooltip>
            )}

            {filter.hasNoProperty && (
                <Chip className={styles.animatedFadeIn}
                    variant="outlined"
                    label="Lead has no property"
                    icon={<PropertiesIcon />}
                    onDelete={() => setFilter({ hasNoProperty: false })}
                />
            )}

            {isFilteringByPropertyLabels && (
                <Tooltip title={propertyLabelsFilterLabel}>
                    <div>
                        <Chip className={styles.animatedFadeIn}
                            variant="outlined"
                            label={propertyLabelsFilterLabel}
                            icon={<PropertiesIcon />}
                            onDelete={() => setFilter({ propertyLabelIds: [] })}
                        />
                    </div>
                </Tooltip>
            )}
        </>
    );
}
